const DEFAULT_HEX_COLOR = "#222B2D";

export function normalizeHexColor(color, fallback = DEFAULT_HEX_COLOR) {
  const normalized = String(color || fallback)
    .trim()
    .replace(/^#/, "");

  if (/^[0-9a-fA-F]{3}$/.test(normalized)) {
    return `#${normalized
      .split("")
      .map((character) => `${character}${character}`)
      .join("")}`.toUpperCase();
  }

  if (/^[0-9a-fA-F]{6}$/.test(normalized)) {
    return `#${normalized}`.toUpperCase();
  }

  return fallback;
}

export function mixHexColor(color, targetColor, amount) {
  const source = normalizeHexColor(color).slice(1);
  const target = normalizeHexColor(targetColor).slice(1);
  const ratio = Math.min(Math.max(Number(amount), 0), 1);
  const mixed = [0, 2, 4]
    .map((offset) => {
      const sourceChannel = parseInt(source.slice(offset, offset + 2), 16);
      const targetChannel = parseInt(target.slice(offset, offset + 2), 16);
      const channel = Math.round(
        sourceChannel + (targetChannel - sourceChannel) * ratio,
      );

      return channel.toString(16).padStart(2, "0");
    })
    .join("");

  return `#${mixed}`.toUpperCase();
}

export function lightenHexColor(color, amount = 0.5) {
  return mixHexColor(color, "#FFFFFF", amount);
}

export function darkenHexColor(color, amount = 0.4) {
  return mixHexColor(color, "#000000", amount);
}
